import type { DealStage, ListDealsFilters } from '../api/deals.client.js';

export type DealViewMode = 'kanban' | 'list' | 'cards';
export type DealActivityFilter = 'all' | 'due' | 'missing';

export interface DealWorkbenchFilters {
  query: string;
  stage: DealStage | 'all';
  ownerId: string;
  activity: DealActivityFilter;
}

export const DEFAULT_DEAL_FILTERS: DealWorkbenchFilters = {
  activity: 'all',
  ownerId: 'all',
  query: '',
  stage: 'all',
};

/**
 * Фильтры панели → параметры запроса. Отбор идёт на сервере
 * (`GET /deals?q=&stage=&ownerId=&activity=`): раньше страница забирала все
 * сделки воркспейса и отсеивала лишние в браузере.
 *
 * `all` — это «фильтр не задан», поэтому в запрос такое значение не попадает.
 */
export function toDealListFilters(filters: DealWorkbenchFilters): ListDealsFilters {
  const query = filters.query.trim();

  return {
    ...(query.length > 0 ? { q: query } : {}),
    ...(filters.stage === 'all' ? {} : { stage: filters.stage }),
    ...(filters.ownerId === 'all' ? {} : { ownerId: filters.ownerId }),
    ...(filters.activity === 'all' ? {} : { activity: filters.activity }),
  };
}

export function getActiveFilterCount(filters: DealWorkbenchFilters): number {
  return [
    filters.query.trim(),
    filters.stage === 'all' ? '' : filters.stage,
    filters.ownerId === 'all' ? '' : filters.ownerId,
    filters.activity === 'all' ? '' : filters.activity,
  ].filter(Boolean).length;
}

export function toggleSelection(selected: ReadonlySet<string>, id: string): Set<string> {
  const next = new Set(selected);

  if (next.has(id)) {
    next.delete(id);
  } else {
    next.add(id);
  }

  return next;
}

export function clearSelection(_selected: ReadonlySet<string>): Set<string> {
  return new Set<string>();
}

export function getFailedSelection(
  selectedIds: readonly string[],
  failedIds: ReadonlySet<string>,
): Set<string> {
  return new Set(selectedIds.filter((id) => failedIds.has(id)));
}
